import emotionNormalize from 'emotion-normalize';
import { injectGlobal } from 'react-emotion';

import Style from './common';

injectGlobal`
  ${emotionNormalize};

  * {
    box-sizing: border-box;
  }

  html,
  body {
    color: ${Style.color.defaultText};
    font-family: ${Style.FONT_FAMILY.DEFAULT};
    font-size: 16px;
    font-weight: ${Style.FONT_WEIGHT.REGULAR};
    margin: 0;
    padding: 0;
    width: 100%;
  }
  
  html,
  body,
  #root,
  // For ConnectedRouter div
  #root > div {
    height: 100%; 
  }
`;



// WEBPACK FOOTER //
// ./src/styles/globalStyles.js